import { reducer as reducer$1 } from "./posts/slice.js";
//#region src/redux/reducer.ts
var reducer = { posts: reducer$1 };
//#endregion
export { reducer };

//# sourceMappingURL=reducer.js.map